import type { TFunction } from 'i18next';

import { IUser } from '../../../types/interfaces/user';
import * as endpoints from '../../endpoints';
import { AgreementType } from './interfaces';

function isAgreementAccepted(
  raw: Record<string, unknown>,
  type: AgreementType,
): boolean {
  const snakeKey =
    type === AgreementType.COOKIE_POLICY
      ? 'cookie_policy'
      : type === AgreementType.TERMS_OF_USE
        ? 'terms_of_use'
        : 'privacy_policy';
  const v = raw[type] ?? raw[snakeKey];
  return v === true;
}

export const AGREEMENT_TITLE_KEY_BY_TYPE: Record<AgreementType, string> = {
  [AgreementType.COOKIE_POLICY]: 'agreements.cookiePolicyTitle',
  [AgreementType.TERMS_OF_USE]: 'agreements.termsOfUseTitle',
  [AgreementType.PRIVACY_POLICY]: 'agreements.privacyPolicyTitle',
};

export const AGREEMENT_CONTENT_PATH_BY_TYPE: Record<AgreementType, string> = {
  [AgreementType.COOKIE_POLICY]: endpoints.Agreements.COOKIES,
  [AgreementType.TERMS_OF_USE]: endpoints.Agreements.TERMS,
  [AgreementType.PRIVACY_POLICY]: endpoints.Agreements.PRIVACY,
};

export const REQUIRED_GATE_AGREEMENTS_ORDER: AgreementType[] = [
  AgreementType.COOKIE_POLICY,
  AgreementType.TERMS_OF_USE,
  AgreementType.PRIVACY_POLICY,
];

export function getFirstMissingGateAgreementType(
  me: IUser | null | undefined,
): AgreementType | null {
  if (!me) {
    return null;
  }

  const agreements = me.agreements;
  if (!agreements) {
    return REQUIRED_GATE_AGREEMENTS_ORDER[0] ?? null;
  }

  const raw = agreements as unknown as Record<string, unknown>;
  return (
    REQUIRED_GATE_AGREEMENTS_ORDER.find(
      (type) => !isAgreementAccepted(raw, type),
    ) ?? null
  );
}

export const REQUIRED_SIGN_UP_AGREEMENTS: AgreementType[] = [
  AgreementType.TERMS_OF_USE,
  AgreementType.PRIVACY_POLICY,
];

export function getSignUpAgreementsValidationMessage(t: TFunction): string {
  const [firstAgreementType, secondAgreementType] = REQUIRED_SIGN_UP_AGREEMENTS;

  return t('formikValidation.agreementsRequired', {
    firstAgreement: t(AGREEMENT_TITLE_KEY_BY_TYPE[firstAgreementType]),
    secondAgreement: t(AGREEMENT_TITLE_KEY_BY_TYPE[secondAgreementType]),
  });
}
